const aiChatSkillPopperStyles = {
  popper: {
    zIndex: "tooltip",
  },
  menu: {
    marginBottom: "0.5rem",
    overflow: "hidden",
    width: "22rem",
  },
  menuItem: {
    alignItems: "flex-start",
    paddingX: "0.75rem",
    paddingY: "0.5rem",
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: "action.hover",
    },
  },
};

export default aiChatSkillPopperStyles;
